import React from 'react';
import { ThankYouParent as ThankYouScreen } from '@features/thank-you';

export const ThankYouParent = (props: any) => <ThankYouScreen {...props} />;
